import { Avatar, Button, Form, Input, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect } from "react";
import { addKeyInArray } from "../../../helpers/siteConfig";
import {
  getAllUsersAsync,
  userUpdatePasswordAsync,
} from "../../../store/features/NP/resource/resourceAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import { CustomTableProps } from "../../../types";
import {
  GetAllUsersData,
  GetAllUsersParams,
  TableData,
} from "../../../types/redux";
import { capitalize, firstChar } from "../../../utils/string";
import { formatDate } from "../../../utils/time";
import CustomTable from "../../common/CustomTable";
import { log } from "console";
import EditIcon from "../../../assets/icons/EditIcon";
import PassKeyIcon from "../../../assets/icons/PassKeyIcon";
import useModal from "../../../hooks/useModal";
import ConfirmModal from "../../common/ConfirmModal";

type Props = {
  keyword?: string;
} & CustomTableProps;

export default function UserTable({
  keyword = "",
  page,
  limit,
  isFirstPage,
  handlePagination,
  handleSetFirstPage,
}: Props) {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const {
    open: confirmOpen,
    toggle: confirmToggle,
    handleOpen: handleConfirmOpen,
  } = useModal();

  const { login } = useAppSelector((state) => state.login);
  const { loading, allUsers, usersCount, updatePasswordLoading } =
    useAppSelector((state) => state.resource);

  useEffect(() => {
    const params: GetAllUsersParams = {
      limit: limit,
      skip: limit * (page - 1),
      isPG: false,
      suppler: "",
    };

    const searchParams: GetAllUsersParams = {
      isPG: false,
      lastName: keyword,
      suppler: "",
    };

    dispatch(
      getAllUsersAsync({
        params: keyword ? searchParams : params,
      })
    );
  }, [dispatch, keyword, limit, login?.suppler, page]);

  useEffect(() => {
    if (keyword && isFirstPage) {
      handlePagination(1, 10);
      handleSetFirstPage(false);
    }
  }, [handlePagination, handleSetFirstPage, isFirstPage, keyword]);

  const columns: ColumnsType<TableData<GetAllUsersData>> = [
    {
      title: "Name",
      render: (val: GetAllUsersData) => (
        <Space className="table_column_title" size={0} direction="horizontal">
          <Avatar size={45}>{firstChar(val?.firstName)}</Avatar>
          {/* <Avatar src={IMG} size={44}></Avatar> */}
          <div className="ml-[8px]">
            <h5>{`${val?.firstName} ${val?.lastName ? val?.lastName : ""}`}</h5>
            <p className="mb-0.5">Email: {val?.email}</p>
            <p>Mobile: {val?.phoneNumber}</p>
          </div>
        </Space>
      ),
    },
    ...(login?.role === "vendor" ||
    login?.role === "cluster" ||
    login?.role === "edatco"
      ? [
          {
            title: "Cluster",
            align: "center" as const,
            dataIndex: "region",
            render: (val: GetAllUsersData) => (
              <span>
                {val?.regionName ? capitalize(val?.regionName) : "N/A"}
              </span>
            ),
          },
        ]
      : []),

    {
      title: "Role",
      align: "center" as const,
      render: (val: GetAllUsersData) => (
        <span>
          {val?.role
            ? roleList[val?.role as string] || capitalize(val?.role)
            : "N/A"}
        </span>
      ),
    },

    // {
    //   title: "Total Minutes of Work (HH:MM)",
    //   align: "center",
    //   render: (val: GetAllUsersData) => (
    //     <span>{minutesToHours(val.totalMinutesOfWork || 0)} min</span>
    //   ),
    // },
    // {
    //   title: "Total Amount",
    //   align: "center",
    //   render: (val: GetAllUsersData) => <span>{val.totalAmount || 0} BDT</span>,
    // },
    // {
    //   title: "Total Rating",
    //   align: "center",
    //   render: (val: GetAllUsersData) => (
    //     <span>{fixedNumber(val?.rating / val?.numberOfTask)}</span>
    //   ),
    // },
    {
      title: "Creation Date",
      align: "center",
      dataIndex: "createdAt",
      render: (val) => <span>{formatDate(val)}</span>,
    },
    // {
    //   title: "Payment Status",
    //   align: "center",
    //   render: (val: GetAllUsersData) => <span>-</span>,
    // },
    {
      title: "Action",
      align: "center",
      render: (val: GetAllUsersData, record: any) => (
        <div className="flex justify-center">
          <Button
            className="flex items-center gap-2 !text-[#33AB29] !border-none !bg-[#33AB291A]"
            onClick={() =>
              handleConfirmOpen({
                type: "FORGORT_PASSWORD",
                data: record,
              })
            }
          >
            <EditIcon color="#33AB29" />
            <span>Edit</span>
          </Button>
        </div>
      ),
    },
  ];

  const onFinish = (values: any) => {
    const newData = {
      userId: confirmOpen?.data?._id,
      password: values.password,
      confirmPassword: values.confirmPassword,
    };

    if (newData) {
      dispatch(
        userUpdatePasswordAsync({
          data: newData,
          others: { reRender },
        })
      );
    }
  };

  function reRender(val: boolean) {
    if (val) {
      confirmToggle();
      form.resetFields();
    }
  }

  return (
    <>
      {confirmOpen?.type === "FORGORT_PASSWORD" && (
        <ConfirmModal
          open={confirmOpen?.open}
          data={confirmOpen?.data}
          handleClose={confirmToggle}
          deleteLoading={loading}
          handleYes={() => {}}
          buttonText=""
          title={""}
          hideAlert={true}
          deleteTitle=""
          questionText=""
          buttonFooterBlank={true}
          width={600}
        >
          <div className="self-stretch justify-start !text-[#2D3643] text-xl font-semibold mb-4">
            Password Reset
          </div>

          <Form
            className="custom-form hide_star_mark custom-password-change-form"
            layout="vertical"
            onFinish={onFinish}
            size="large"
            form={form}
          >
            <Form.Item
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: "Please enter password",
                },
                {
                  min: 9,
                  message: "Password must be minimum 9 characters",
                },
              ]}
            >
              <Input.Password
                // prefix={<PassKeyIcon />}
                size="large"
                placeholder="Password"
              />
            </Form.Item>
            <Form.Item
              name="confirmPassword"
              label="Confirm Password"
              rules={[
                {
                  required: true,
                  message: "Please enter confirm password",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Password and Confirm password do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password size="large" placeholder="Confirm Password" />
            </Form.Item>

            <div className="w-full justify-end flex gap-2 pt-6">
              <Button
                onClick={() => confirmToggle()}
                className="cancel_btn !bg-[#8897AE] !text-white !border-[2px] !border-transparent hover:!border-[#8897AE] transition-all duration-200"
              >
                Cancel
              </Button>
              <Button
                htmlType="submit"
                type="primary"
                loading={updatePasswordLoading}
              >
                Update
              </Button>
            </div>
          </Form>
        </ConfirmModal>
      )}

      <CustomTable<TableData<GetAllUsersData>>
        loading={loading}
        total={usersCount?.totalUsers}
        page={page}
        handlePagination={handlePagination}
        columns={columns}
        dataList={addKeyInArray(allUsers)}
        isPagination={keyword ? false : true}
      />
    </>
  );
}

const roleList: Record<string, string> = {
  region: "Cluster",
  area: "Zonal",
};
